import GrandLayout from '../../layouts/GrandLayout/GrandLayout';
import GrandPageAnimatedSections from '../../features/GrandPage/GrandPageAnimatedSections/GrandPageAnimatedSections';
import { Link, useSearchParams } from 'react-router-dom';
import { Modal, TextInput, Button, Loader, Flex, Center, Stack } from '@mantine/core';
import { useRef, useState, useEffect, createRef } from 'react';
import showNotification from "../../utils/showNotification";
import axios from 'axios';
import PhoneInputField from '../../components/PhoneInputField/PhoneInputField';
import { useForm } from '@mantine/form';
import { Helmet } from "react-helmet";
import { isValidPhoneNumber } from 'react-phone-number-input';
import { IconBrandWhatsapp, IconCopy } from '@tabler/icons-react';

const DISCOUNT_CODE = 'IPG-FV-15'
export default function GrandPage() {
    const [isCopied, setCopied] = useState(false)

    const handleCopy = () => {
        navigator.clipboard.writeText(DISCOUNT_CODE)
            .then(() => {
                setCopied(true)
                setTimeout(() => {
                    setCopied(false)
                }, 1000)
            })
            .catch((err) => {
                console.log(err)
            })
    }


    const [searchParams] = useSearchParams();
    const utm_source = searchParams.get("utm_source")
    const campaing = searchParams.get("campaing")
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const hasShownModal = useRef(false);

    const [isDiscountModal, setIsDiscountModal] = useState(campaing ? true : false)

    const handleFormSubmit = async (values) => {

        try {
            setIsLoading(true)
            const data = {
                channel: 'web-transferencias',
                message: `Mensaje recibido desde la página GranD:
             Nombre: ${values.name},
             Email: ${values.email},
             Teléfono: ${values.phone},
            `
            }
            await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/info/slack`, data)

            setShowModal(false);
            showNotification({
                message: "Vamos a estar en contacto contigo muy pronto.",
                status: "success",
                color: "green",
                title: "Operación exitosa!"
            })

        } catch (err) {
            console.error(err);
            showNotification({
                message: "Ha ocurrido un error y no hemos procesado el pedido. Por favor intenta nuevamente.",
                status: "success",
                color: "red",
                title: "Error"
            })
        } finally {
            setIsLoading(false)
        }
    };

    const ref = createRef()
    const form = useForm({
        initialValues: {
            name: '',
            email: '',
            phone: '',
        },

        validate: {
            phone: (value) => {
                if (typeof value === "string")
                    return !isValidPhoneNumber(value)
                else return true
            }
        },
    });

    useEffect(() => {
        if (utm_source && !hasShownModal.current) {
            hasShownModal.current = true;

            const timer = setTimeout(() => {
                setShowModal(true);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <>
            <Helmet>
                <title>GranD | Inicio</title>
                <meta name="description"
                    content="Una iniciativa desarrollada por FORVET,
en colaboración estratégica con IPG IRIBARREN. Una unidad de formación para potenciar el conocimiento técnico, ético y práctico de profesionales del campo veterinario" />
                <meta property="og:title" content="GranD | Inicio" />
                <meta property="og:description"
                    content="Una iniciativa desarrollada por FORVET,
en colaboración estratégica con IPG IRIBARREN. Una unidad de formación para potenciar el conocimiento técnico, ético y práctico de profesionales del campo veterinario" />
            </Helmet>
            <GrandLayout>
                <GrandPageAnimatedSections />


                <Modal opened={showModal} onClose={() => setShowModal(false)} styles={{
                    root: {
                        background: "red"
                    }
                }}>
                    <h3
                        style={{ fontSize: 'var(--fs-body)', textAlign: 'center', marginBottom: '2rem' }}
                    >¿Querés que te contemos cuáles son las promociones de lanzamiento y los beneficios que tenemos para vos?
                    </h3>
                    <p
                        style={{ fontSize: 'var(--fs-small)', textAlign: 'center', marginBottom: '2rem' }}
                    >Completá este formulario y te lo enviamos por WhatsApp o email.</p>
                    <form onSubmit={form.onSubmit((values) => handleFormSubmit(values))} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <TextInput
                            label="Nombre"
                            placeholder="Tu nombre"
                            {...form.getInputProps('name')}
                            styles={{
                                input: {
                                    backgroundColor: 'transparent',
                                    border: '1px solid #32BAD9'
                                }
                            }}
                            mb="sm"
                        />

                        <PhoneInputField
                            ref={ref}
                            name="phone"
                            styles={{ input: { background: 'transparent', border: "1px solid #32BAD9" } }}
                            fieldError={form.errors.phone}
                            {...form.getInputProps("phone")}
                        />
                        <TextInput
                            label="Email"
                            placeholder="Tu email"
                            styles={{
                                input: {
                                    backgroundColor: 'transparent',
                                    border: '1px solid #32BAD9'
                                },

                            }}

                            name="email"
                            {...form.getInputProps('email')}
                            mb="sm"
                        />

                        <Button my={20} type="submit" fullWidth color='#32BAD9'>
                            {isLoading ? <Loader /> : "Enviar"}
                        </Button>
                    </form>
                </Modal>

                <Modal opened={isDiscountModal} onClose={() => setIsDiscountModal(false)} styles={{
                    root: {
                        background: "red"
                    }
                }}>
                   <Stack gap='1rem'>
                     <h3
                        style={{ fontSize: 'var(--fs-body)', textAlign: 'center'}}
                    >Aprovecha este descuento en cualquier curso que elijas
                    </h3>


                    <div style={{width: "100%", 
                    maxWidth: "max-content",margin: 'auto', padding:'1rem',borderRadius: "1rem",justifyContent: 'center', alignItems:'center',
                    backgroundColor: "#ffffff25", textAlign:"center", fontSize:"var(--fs-body)"}}><span style={{
                        fontSize:"var(--fs-h3)", fontWeight: 700
                    }}>15%</span> <span>de</span> <br/>
                        <span>descuento</span>
                    </div>

                    <p
                        style={{ fontSize: 'var(--fs-small)', textAlign: 'center' }}
                    >Copia y pegá este código en la capacitación elegida</p>

                    <Flex style={{padding:"1rem", border: "1px solid", borderRadius: '1rem'}} justify='center' align='center' gap={'.5rem'}>
                        <p style={{ fontFamily: "monospace", fontSize: "var(--fs-h3)", textAlign: 'center' }}>{DISCOUNT_CODE}</p>
                    < IconCopy style={{cursor: 'pointer'}} onClick={handleCopy} color={isCopied ? '#32BAD9' : '#fff'} />
                    </Flex>

                    <Stack gap={0}>
                        <h4 style={{fontSize: "var(--fs-body)", textAlign:'center'}}>¿Necesitás ayuda?</h4>
                    <Link target='_blank' to="https://wa.me/+5493512086545?text=¡Hola!%20Buenos%20días,%20tengo%20una%20consulta..." style={{fontSize: "var(--fs-small)", textAlign:'center', display: 'flex', alignItems: 'center', gap: ".5rem", color: 'inherit', justifyContent:'center'}}>
                    <IconBrandWhatsapp/>
                    Comunicate con nosotros</Link>
                    </Stack>

                   <Center>
                     <Button onClick={() => setIsDiscountModal(false)}>Aceptar</Button>
                   </Center>
                   </Stack>
                </Modal>
            </GrandLayout>
        </>

    )
}